// @core/api/endpoints/task/update_task_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TaskTypeDefinitionResponse,
  UpdateTaskTypeRequest,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Update task type
 * Updates a task type definition (default priority, lifecycle flags, status configuration).
 */
export async function UpdateTaskType(
  type_id: string,
  data: UpdateTaskTypeRequest,
  options?: RequestOptions
): Promise<TaskTypeDefinitionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/task-types/:type_id`;
  requestPath = requestPath.replace(':type_id', encodeURIComponent(type_id));
  const requestOptions = options;
  return client.put<TaskTypeDefinitionResponse>(requestPath, data, requestOptions);
}
